<div class="p-4">
    <div class="container">
        <li *ngFor="let usuario of dataUsuarios">
            {{ usuario.nombre }}
            {{ usuario.apellido1 }}     
          </li>
    </div>
</div>